import PageTitle from "../Components/PageTitle";

import KentAndMedwayLogo from "../Assets/KentAndMedwayLogo.png";
import CqcLogo from "../Assets/CqcLogo.png";

export default function Regulation() {
  return (
    <div>
      <PageTitle title={"Regulation"} />

      <div className="mt-5 mb-16 lg:mb-20 px-10 lg:px-[15vw]">
        <h1 className="text-3xl mb-6 font-bold text-en-blue">Regulation</h1>

        <div className="space-y-10">
          <section>
            <h2 className="text-2xl mb-3 font-bold text-en-blue">Nursing and Midwifery Council (NMC)</h2>
            <p className="text-lg">
              As a registered nurse, Lauren is regulated by the NMC, the independent professional
              regulator for nurses, midwives and nursing associates in the UK. This means she is
              required to meet the NMC&apos;s rigorous standards of education, training, competence,
              and professional conduct in order to maintain her registration. Lauren is accountable
              for providing safe, effective, evidence-based care and must adhere to the principles
              set out in the NMC Code, which places patient safety, dignity, and wellbeing at the
              centre of all nursing practice.
            </p>
            <br />
            <p className="text-lg">
              To remain on the NMC register, Lauren must regularly renew her registration,
              demonstrate ongoing professional development, and participate in a process known as
              revalidation. This ensures her knowledge and skills remain current and that she
              continues to deliver care in line with the latest professional standards. Being
              regulated by the NMC provides reassurance that Lauren practices ethically, maintains
              confidentiality, works within her professional scope of practice, and is committed to
              delivering high-quality care to every patient she treats.
            </p>
            <br />
            <p className="text-lg">
              For patients, NMC registration offers confidence that Lauren is professionally
              qualified, accountable for her actions, and subject to robust regulatory oversight
              designed to protect the public and uphold standards within the nursing profession.
            </p>
            <p className="text-lg mt-4">
              <a
                href="https://www.nmc.org.uk/"
                target="_blank"
                rel="noreferrer"
                className="text-blue-700 underline"
              >
                Read more about the Nursing and Midwifery Council&apos;s work on their website
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3 font-bold text-en-blue">Care Quality Commission (CQC)</h2>
            <p className="text-lg">
              The Care Quality Commission (CQC) is the independent regulator of health and social
              care services in England. Its role is to monitor, inspect and regulate services to
              ensure they provide people with safe, effective, caring, responsive and well-led
              care.
            </p>
            <br />
            <p className="text-lg">
              For patients, CQC regulation provides reassurance that a service is being held
              accountable to nationally recognised standards. Registered providers must demonstrate
              that they have appropriate systems and processes in place to protect patient safety,
              manage risks, maintain accurate records, safeguard personal information, and ensure
              staff are suitably trained and competent.
            </p>
            <br />
            <p className="text-lg">
              CQC-regulated services are subject to inspection and ongoing oversight, helping to
              ensure that care is delivered consistently and in accordance with legal requirements
              and best practice. The CQC can take action where standards are not met, with the
              primary aim of protecting the public and improving the quality of care.
            </p>
            <br />
            <p className="text-lg">
              For patients, CQC registration is an indication that a service has met specific
              regulatory requirements and is committed to providing care that is safe, professional,
              and focused on patient wellbeing.
            </p>
            <p className="text-lg mt-4">
              <a
                href="https://www.cqc.org.uk/"
                target="_blank"
                rel="noreferrer"
                className="text-blue-700 underline"
              >
                Read more about the Care Quality Commission&apos;s work on their website
              </a>
            </p>
          </section>

          <section>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
              <a
                href="https://www.cqc.org.uk/location/1-14165488472"
                target="_blank"
                rel="noreferrer"
                className="flex justify-center"
              >
                <img
                  src={KentAndMedwayLogo}
                  alt="Part of Kent and Medway Ear Care"
                  className="w-full max-w-[360px] object-contain"
                />
              </a>

              <div className="flex justify-center">
                <img
                  src={CqcLogo}
                  alt="Regulated by Care Quality Commission"
                  className="w-full max-w-[360px] object-contain"
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
